import React from 'react';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { UserApi } from '../../redux/api/UserApi';
import { GameplanApi } from '../../redux/api/GameplanApi';
import { Card, CardHeader, CardBody, TabStrip, TabStripTab, TabStripSelectEventArguments } from '@progress/kendo-react-layout';
import * as svg from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartSeriesLabels, ChartTitle, ChartTooltip, } from '@progress/kendo-react-charts';
import { useCurrentUserContext } from '../../context/UserContext';

const Effort: React.FC<ITicketProps> = (ticket) => {
    const { profile } = useCurrentUserContext();
    const { data: workstream } = GameplanApi.useGetTicketWorkstreamQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const { data: allocation } = GameplanApi.useGetTicketAllocationQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const myAllocation = allocation?.find(a => a.Contact_Id === profile.Id);
    const [view, setView] = React.useState('Chart');

    const chartSeries = [
        {
            name: 'Your Effort',
            data: [
                {
                    category: 'Complete',
                    value: Math.min(myAllocation?.Percent_Complete_Value, 100.0),
                    color: '#94e2fc'
                },
                {
                    category: 'Remaining',
                    value: 100.0 - Math.min(myAllocation?.Percent_Complete_Value, 100.0),
                    color: '#ddd'
                }
            ]
        },
        {
            name: 'This ' + profile.Phrases.CallPhrase,
            data: [
                {
                    category: 'Complete',
                    value: Math.min(workstream?.Percent_Complete, 100.0),
                    color: '#94e2fc'
                },
                {
                    category: 'Remaining',
                    value: 100.0 - Math.min(workstream?.Percent_Complete, 100.0),
                    color: '#ddd'
                }
            ]
        }
    ];

    const [selected, setSelected] = React.useState<number>(-1);

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected);
    }
    const labelContent = (e: any) => e.category === 'Complete' ? `${(Math.round(e.value * 100) / 100).toFixed(0)}%` : null;
    const renderTooltip = (context: any) => {
        const { category, series, value } = context.point || context;
        return (
            <div>
                {category} ({series.name}): {(Math.round(value * 100) / 100).toFixed(2)}%
            </div>
        );
    };
    if (profile?.Features.External_Interface || !workstream || !myAllocation) return null;

    return (<>
        <Card className="ownership effort">
            <CardHeader>
                <i><SvgIcon size='large' icon={svg.clockArrowRotateIcon} className='mr-2' ></SvgIcon></i>
                {view === 'Percent' ? 'Effort' : 'Completion'}<SvgIcon icon={svg.hyperlinkOpenIcon} className='d-none' />
                <i className='options'>
                    <ButtonGroup>
                        <Button onClick={() => setView('Percent')} svgIcon={svg.percentIcon} defaultChecked={true} className={view === 'Percent' ? 'on' : 'off'} />
                        <Button onClick={() => setView('Chart')} svgIcon={svg.chartDoughnutIcon} className={view === 'Percent' ? 'off' : 'on'} />
                    </ButtonGroup>
                </i>
            </CardHeader>
            <CardBody>
                {view === 'Percent' ? <>
                    <div className='header'>
                        <div className='col-6'>my completion</div>
                        <div className='col-6'>my hours</div>
                    </div>
                    <div className="info">
                        <div className='col-6'>{myAllocation?.Percent_Complete}</div>
                        <div className='col-6'>{myAllocation?.Logged_Time_Bind}</div>

                    </div>
                </> :
                    <div className='charts relative'>
                        {/* <TabStrip selected={selected} onSelect={handleSelect}>
                            <TabStripTab title="Your Effort" >
                                <div className=''>

                                </div>
                            </TabStripTab >
                            <TabStripTab title="This Ticket" >
                                <div className=''>

                                </div>
                            </TabStripTab >
                        </TabStrip> */}
                        <h6>Your Effort vs {profile.Phrases.CallPhrase} Total</h6>
                        <Chart className='w-100 c-1' transitions={false} >
                            <ChartSeries>
                                {chartSeries.map((series, index, array) => (
                                    <ChartSeriesItem
                                        type="donut"

                                        name={series.name}
                                        data={series.data}
                                        field="value"
                                        categoryField="category"
                                        colorField="color"
                                    >
                                        <ChartSeriesLabels position="center" background="none" color='#000' content={labelContent} />
                                        {/* {index === array.length - 1 && (
                                        
                                        )} */}
                                    </ChartSeriesItem>
                                ))}
                            </ChartSeries>
                            <ChartLegend visible={false} />
                            <ChartTooltip render={renderTooltip} />
                        </Chart>
                        {/* <Chart className='w-100 c-1' donutCenterRender={() => {
                            return <>This {profile.Phrases.CallPhrase}</>
                        }}>
                            <ChartSeries>
                                <ChartSeriesItem type="donut" data={ticketCompleteData} categoryField="label" field="value">
                                    <ChartSeriesLabels content={(null)} format='{0:f}%' />
                                </ChartSeriesItem>
                            </ChartSeries>
                            <ChartLegend visible={false} />
                        </Chart> */}

                    </div>
                }

            </CardBody></Card >


    </>

    );
};

export default Effort;